const API_BASE = import.meta.env.VITE_API_URL ?? "";

export type ApiError = { error: string; details?: unknown };

export async function api<T>(
  path: string,
  options: RequestInit & { token?: string; csrf?: string } = {},
): Promise<T> {
  const headers = new Headers(options.headers);
  if (!headers.has("Content-Type") && options.body) {
    headers.set("Content-Type", "application/json");
  }
  if (options.token) headers.set("Authorization", `Bearer ${options.token}`);
  if (options.csrf) headers.set("X-CSRF-Token", options.csrf);

  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers,
    credentials: "include",
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(
      (data as ApiError).error || `Request failed (${res.status})`,
    ) as Error & { status: number; details?: unknown };
    err.status = res.status;
    err.details = (data as ApiError).details;
    throw err;
  }
  return data as T;
}
